import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { rootReducer } from '@wellesley/store'

type RouterState = {
  path: string
  transitionPath: string
}

const initialState: RouterState = {
  path: '',
  transitionPath: '',
}

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    setPath: (state, { payload }: PayloadAction<string>) => {
      if (payload !== state.path) {
        state.path = payload
      }
    },
    requestChangePath: (state, { payload }: PayloadAction<string>) => {
      if (payload !== state.transitionPath) {
        state.transitionPath = payload
      }
    },
  },
  selectors: {
    selectPath: (state) => state.path,
    selectTransitionPath: (state) => state.transitionPath,
  },
}).injectInto(rootReducer)
